/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProviderComponentNetwork } from './providerComponentNetwork';
import { KeyValuePair } from './keyValuePair';
import { ProviderComponentInventoryTree } from './providerComponentInventoryTree';
import { ProviderComponentMetadata } from './providerComponentMetadata';
import { ProviderComponentCommerce } from './providerComponentCommerce';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';
import { ProviderComponentCloudProviderInfo } from './providerComponentCloudProviderInfo';


export interface ProviderComponent { 
    /**
     * Component build info
     */
    build_info?: Array<KeyValuePair>;
    cloud_provider_info?: ProviderComponentCloudProviderInfo;
    commerce?: ProviderComponentCommerce;
    /**
     * Component identifier
     */
    component_id: string;
    /**
     * Component type
     */
    component_type: string;
    inventory?: ProviderComponentInventoryTree;
    /**
     * Component metadata
     */
    metadata?: Array<ProviderComponentMetadata>;
    /**
     * Component name
     */
    name: string;
    network?: ProviderComponentNetwork;
    /**
     * Org Id
     */
    org_id: string;
    /**
     * Release type
     */
    release_type?: string;
    /**
     * Report time for the component
     */
    report_time: Date;
    vcds_service_type?: VcdsServiceTypeEnum;
    /**
     * Component version
     */
    version: string;
}
export namespace ProviderComponent {
}


